module.exports = __webpack_public_path__ + "static/media/edit-icon.6d80a917.svg";